/*
 * @Author: czj
 * @Date: 2025-04-17 17:30:45
 * @Description: 
 * @FilePath: \kp-rag-system\src\api\index.js
 */
import request from '@/utils/request';
// 默认get请求
export function default_request_method_get(url, params) {
  return request({
    url: url,
    method: 'get',
    params
  })
}

//数据集-分页
export function dataset_page(params) {
  return request({
    url: '/api/dataset/single_cell_data',
    method: 'get',
    params
  })
}
//数据集-详情
export function dataset_detail(id) {
  return request({
    url: '/api/dataset/single_cell_data/' + id,
    method: 'get'
  })
}
//数据集-删除
export function dataset_delete(id) {
  return request({
    url: '/api/dataset/single_cell_data/' + id,
    method: 'delete'
  })
}
//数据集-创建
export function dataset_create(data) {
  return request({
    url: '/api/dataset/single_cell_data',
    method: 'post',
    data
  })
}
//数据集-修改
export function dataset_update(id, data) {
  return request({
    url: '/api/dataset/single_cell_data/' + id,
    method: 'put',
    data
  });
}




//有用注册
export function useful_register(data) {
  return request({
    url: '/api/register',
    method: 'post',
    data
  })
}
//账号密码登录
export function login_account_pwd(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data
  })
}
//登出
export function logout() {
  return request({
    url: '/api/logout',
    method: 'post'
  })
}
//获取用户信息
export function get_user_info() {
  return request({
    url: '/api/user',
    method: 'get'
  })
}




//获取手机验证码
export function get_phone_code(data) {
  return request({
    url: '/api/send_code_phone',
    method: 'post',
    data
  })
}
//手机修改密码
export function update_password_phone(data) {
  return request({
    url: '/api/sms_pwd',
    method: 'post',
    data
  })
}
//手机登录
export function login_phone(data) {
  return request({
    url: '/api/sms_login',
    method: 'post',
    data
  })
}

//获取邮箱验证码
export function get_email_code(data) {
  return request({
    url: '/api/send_code_mail',
    method: 'post',
    data
  })
}
//邮箱修改密码
export function update_password_email(data) {
  return request({
    url: '/api/mailpwd',
    method: 'post',
    data
  })
}
//邮箱登录
export function login_email(data) {
  return request({
    url: '/api/mail_login',
    method: 'post',
    data
  })
}



//获取项目配置信息
export function get_project_config() {
  return request({
    url: '/api/system_conf',
    method: 'get'
  })
}